import { createSelector } from '@reduxjs/toolkit';
import camelcaseKeys from 'camelcase-keys';
import { getProductTypeEntitiesById as getQTProductTypeEntities } from '../types';

const getProductTypeEntitiesById = (state) =>
  state?.sealink?.product_types || {};

const getProductTypes = createSelector(
  [getQTProductTypeEntities, getProductTypeEntitiesById],
  (qtProductTypesById, cmsProductTypes) =>
    Object.values(cmsProductTypes).map((productType) => {
      const cmsType = camelcaseKeys(productType);
      const qtProductType = camelcaseKeys(qtProductTypesById[cmsType.qtId]);
      return {
        ...qtProductType,
        ...cmsType,
      };
    })
);

export { getProductTypes };
